import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/analysis/car-overview");
